import { useCallback, useEffect, useState } from 'react'
import { useInterval } from '../hooks/useInterval'
import { ModalEnum } from '../interfaces'
import { getMe } from '../services/users'
import { useStores } from '../stores/RootStoreContext'

const TestExpirationEvent = () => {
  const TIMER = 1000 * 10 // 10 seconds

  const { modalStore } = useStores()
  const [hasExpired, setHasExpired] = useState(false)

  const getToken = () => localStorage.getItem('token')

  const checkExpiration = useCallback(async () => {
    const token = getToken()
    if (!token) return

    await getMe().then(({ data }) => {
      if (data) {
        const { userSubscription, companySubscription } = data
        const { subscriptionStatus, subscriptionPaused, subscriptionCanceled, planName } = companySubscription
        const { role } = data.user

        if (
          ((subscriptionStatus !== 'trialing' &&
            subscriptionStatus !== 'active' &&
              (planName === 'Gratis' || planName === '')) ||
          subscriptionPaused || subscriptionCanceled) && role === 'owner'
        ) {
          // Has expired
          setHasExpired(true)
        } else {
          // Not expired
          setHasExpired(false)
        }
      }
    }).catch((error) => {
      console.error('Erro ao verificar expiração:', error)
    })
  }, [])

  const { start, stop } = useInterval(checkExpiration, TIMER)

  useEffect(() => {
    if (hasExpired) {
      modalStore.openModal(ModalEnum.TEST_EXPIRED)
      stop()
    }
  }, [hasExpired])

  useEffect(() => {
    start()

    return () => {
      stop()
    }
  }, [])

  return null
}

export default TestExpirationEvent
